var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "kpi-grid",
      class: [_vm.isGrow ? "kpi-container-fall" : "kpi-container-grow"]
    },
    _vm._l(_vm.kpis, function(kpi) {
      return _c("kpi", { key: kpi.id, attrs: { kpi_data: kpi } })
    })
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Kpi/Kpicontainer.vue?vue&type=template&id=1d9b0be0&
// module id = null
// module chunks = 